<template>
  <wrapper class="ys-w">
    <header class="h76 title line">服务信息</header>
    <div class="ys-info-w line">
      <div class="h76 ys-name-ctn aflex h-between v-bottom">
        <label>服务月嫂</label>
        <div class="aflex v-bottom" v-if="!isVirtual">
          <avatar class="ys-avatar" :url="worker.headImage" />
          <span class="ys-name">{{ worker.workerName }}</span>
        </div>
        <div class="aflex v-bottom" v-else>
          <span class="ys-name">孩子王{{ starText }}</span>
        </div>
      </div>
      <div
        class="ys-info aflex h-between v-center"
        @click.stop="gotoUserDetail(worker)"
        v-if="!isVirtual"
      >
        <label>月嫂信息</label>
        <div>
          <span>{{ starText }}</span>
          <span>已服务&nbsp;{{ worker.servicedTimes }}次</span>
        </div>
      </div>
    </div>
    <div class="h76 aflex h-between v-center line" v-if="!isVirtual">
      <label>月嫂服务电话</label>
      <a
        class="r aflex v-center"
        :href="`tel:${worker.mobile}`"
        @click="telClick"
        >{{ TEL }}<img class="tel" src="~@/assets/images/order/icon-tel2.png"
      /></a>
    </div>
    <div class="h76 aflex h-between v-center line">
      <label>预计服务时间</label>
      <span class="r">{{ worker.serviceTime }}</span>
    </div>
    <div class="h76 aflex h-between v-center">
      <label>服务地址</label>
      <span class="r">{{ worker.address }}</span>
    </div>
  </wrapper>
</template>
<script>
import wrapper from '../../wrapper'
import avatar from '@/components/avatar'
import { STAR_STANDARD_TXT_MAP } from '@/config'
import { maskTEL } from '@/utils'
import { B_ORDER_YS } from '@/business'
export default {
  components: {
    wrapper,
    avatar
  },
  inject: {
    busiTelTrackParams: {
      default: null
    }
  },
  props: {
    worker: {
      type: Object,
      default() {
        return {}
      }
    },
    area: {
      type: String,
      default: ''
    },
    order: {
      type: Object,
      default() {
        return {}
      }
    },
    isVirtual: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    starText() {
      return STAR_STANDARD_TXT_MAP.get(+this.order.starLevel)
    },
    TEL() {
      return maskTEL(this.worker.mobile)
    }
  },
  methods: {
    gotoUserDetail(user) {
      if (this.$$isMp()) {
        return
      }
      location.href = `/v/user/${user.uid}`
    },
    telClick() {
      this.busiTelTrackParams &&
        this.$$newTrackClick({
          ...this.busiTelTrackParams,
          positionParam: {
            popid: this.order && this.order.businessId
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.ys-w {
  color: #262626;
  font-size: rem(26px);
  line-height: rem(32px);
}
.title {
  font-size: rem(28px);
  font-weight: bold;
  line-height: rem(76px);
}
.line {
  @include border(bottom, #f0f0f0, 1px);
}
.h76 {
  height: rem(76px);
  .r {
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 80%;
  }
  a {
    color: #262626;
    line-height: rem(20px);
  }
  img.tel {
    width: rem(40px);
    margin-left: rem(12px);
  }
}
.ys-name-ctn {
  & label,
  & .ys-name {
    margin-bottom: rem(14px);
  }
}
.ys-avatar {
  width: rem(52px) !important;
  height: rem(52px) !important;
  border-radius: 50%;
}
.ys-name {
  font-weight: 600;
  margin-left: rem(12px);
}
.ys-info {
  height: rem(68px);
  font-size: rem(22px);
  line-height: rem(28px);
  & label {
    color: #808080;
  }
  & div {
    display: flex;
    align-items: center;
    & span {
      &::before {
        position: relative;
        display: inline-block;
        bottom: rem(6px);
        left: rem(-6px);
        content: '';
        width: rem(5px);
        height: rem(5px);
        background-color: #808080;
        border-radius: 50%;
      }
      &:first-child {
        margin-right: rem(20px);
      }
    }
  }
}
</style>
